import { createRoot } from 'react-dom/client';
import React from 'react';
import '@shopify/polaris/build/esm/styles.css';
import AuthApp from './src/AuthApp';

if (document.getElementById('app')) {
  createRoot(document.getElementById('app')).render(<AuthApp />);
}
